import { SelectColor } from 'components/colors/component'
import * as React from 'react'
import { Label } from 'reactstrap'
import { getConfiguration } from '../../utils'
import { TopicPreferencesLayoutAttributes } from '../constants'
import { EditSectionProps } from '../types'

export class AppearanceSettings extends React.Component<EditSectionProps> {
  constructor(props: EditSectionProps) {
    super(props)
  }

  public render() {
    return <div className="logo-size">
      <span className="title">{this.props.name}</span>
      <div className="section">
        <div className="block">
          <div className="title">Topic Card Size</div>
          <div>
            <Label>
              <input
                type="radio"
                name="cardSize"
                value="small"
                checked={this.getCardSize() === 'small'}
                onChange={(e) => {
                  this.props.onChange(TopicPreferencesLayoutAttributes.TopicCardSize, 'small')
                }}
              />
              Small
            </Label>
            <br/>
            <Label>
              <input
                type="radio"
                name="cardSize"
                value="large"
                checked={this.getCardSize() === 'large'}
                onChange={(e) => {
                  this.props.onChange(TopicPreferencesLayoutAttributes.TopicCardSize, 'large')
                }}
              />
              Large
            </Label>
          </div>
        </div>
      </div>
      <div className="section">
        <div className="block">
          <div className="title">Border Colors</div>
          <div>
            <span>Default Border Color</span>
            <SelectColor
              key={TopicPreferencesLayoutAttributes.TopicBorderColor}
              className={'secondary'}
              selectColor={(c: string) => {
                this.props.onChange(TopicPreferencesLayoutAttributes.TopicBorderColor, c)}}
              color={getConfiguration(this.props.data,
                TopicPreferencesLayoutAttributes.TopicBorderColor, '#dee2e6')} />
          </div>
          <div>
            <span>Active Border Color</span>
            <SelectColor
              key={TopicPreferencesLayoutAttributes.ActiveTopicBorderColor}
              className={'secondary'}
              selectColor={(c: string) => {
                this.props.onChange(TopicPreferencesLayoutAttributes.ActiveTopicBorderColor, c)}}
              color={getConfiguration(this.props.data,
                TopicPreferencesLayoutAttributes.ActiveTopicBorderColor, '#7FAE1B')} />
          </div>
        </div>
      </div>
    </div>
  }

  private getCardSize = (): string => {
    return getConfiguration(this.props.data, TopicPreferencesLayoutAttributes.TopicCardSize, 'large')
  }
}
